// ─── STORY DATA ───────────────────────────────────────────────────────────────
// Derived from the same single sources of truth the rest of the site uses
// (industriesData.js + sectorServicesData.js) so this section can never drift
// out of sync with the sector pages or the nav. Nothing is duplicated here —
// this module only *shapes* that data into the beats the story needs.
import { INDUSTRIES } from '../../data/industriesData';
import { SECTORS } from '../../data/sectorServicesData';

// One "chapter" per sector. Each chapter owns the sector's identity plus the
// real services that belong to it — counts vary (Healthcare 5, Utilities 6,
// Industrial 6, Education 4), and every downstream calculation is driven off
// `services.length` rather than a hard-coded number.
export const CHAPTERS = INDUSTRIES.map((industry, chapterIndex) => {
  const sector = SECTORS.find(s => s.to === industry.href);
  const services = (sector?.services || []).map((s, i) => ({
    id: String(i + 1).padStart(2, '0'),
    slug: s.slug,
    title: s.title,
    // `brief` is a full marketing paragraph on the sector pages; the story
    // stage only ever shows one service at a time in a narrow panel, so we
    // take the first sentence and let the service page carry the rest.
    brief: firstSentence(s.brief),
    deliver: (s.deliver || []).slice(0, 3),
    to: `${sector.to}/${s.slug}`,
  }));

  return {
    index: chapterIndex,
    id: industry.id,
    name: industry.name,
    short: industry.short,
    desc: industry.desc,
    tags: industry.tags,
    accent: industry.accent,
    img: industry.img || null,
    to: industry.href,
    services,
  };
});

export const CHAPTER_COUNT = CHAPTERS.length;
export const TOTAL_SERVICES = CHAPTERS.reduce((n, c) => n + c.services.length, 0);

function firstSentence(text) {
  if (!text) return '';
  const trimmed = text.trim();
  // Split on sentence enders that are followed by whitespace + a capital, so
  // abbreviations and decimals inside a sentence don't cut it short.
  const match = trimmed.match(/^[\s\S]*?[.!?](?=\s+[A-Z"'“])/);
  return (match ? match[0] : trimmed).trim();
}
